export class InternalServerError extends Error {
    readonly kind = 'InternalServerError';
    constructor() {
        super('InternalServerError');
    }
}
